module.exports = __webpack_public_path__ + "fb04b70edf77999de0b1be06fab6bcb4.png";